module.exports = __webpack_public_path__ + "319af46a7656b8a77a70291ecf635fe3.png";